// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"e62bfea0","977":"b82a133f"}[chunkId] + ".chunk.js";
};